import { EntityType } from '@frontend/common';
import { IoTClient } from '@frontend/iot/api';
import { IoT } from '@frontend/iot/types';
import { useReactiveObject, useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useIoT:request': CustomEvent<string>;
    }
}

const REQUEST_IOT_EVENT = 'useIoT:request';
const STORAGE_KEY = 'IOT_REQ';

export function iotRequest(iotId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_IOT_EVENT, { detail: iotId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function IoTResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_IOT_EVENT, EntityType.IOT, (ids) => IoTClient.resolveIoTs(ids), props.dispatch);
    return <></>;
}

interface UseIoTResolverProps {
    iotId?: string;
    fetchOnload?: boolean;
}
interface UseIoTResolverReturn {
    iot: IoT | null;
    initialising: boolean;
    isLoading: boolean;
}

/**
 * @description IoTResolver must be present in the app for this to work.
 */
export function useReactiveIoT({iotId, fetchOnload = false}: UseIoTResolverProps): UseIoTResolverReturn {
    const { object: iot, initialising, isLoading } = useReactiveObject<IoT>({ id: iotId, entity_type: EntityType.IOT, fetchOnload, resolveFunction: iotRequest });
    return { iot, initialising, isLoading };
}